<template>
  <div class="logistics-news">
    <div class="newsTop">
      <titleColor :title="asd" />
      <router-link
        :to="{
        name: 'LogisticsInformation',
      }"
      class="topright">
        <text>更多</text>
        <img src="@/assets/home/arrow.png">
      </router-link>
    </div>
    <view class="newsdetail" :style="{ backgroundImage: `url('${firstArticleImageUrl}')` }" @click="openLogistics(firstArticleId)">
      <text>{{ firstArticleTitle }}</text>
    </view>
    <view v-for="item in otherArticles" :key="item.id" class="newslist" @click="openLogistics(item.id)">
      <view></view>
      <span class="news-title">{{ item.title }}</span>
    </view>
    <view></view>
  </div>
</template>

<script>
import titleColor from '@/components/titleColor.vue'
import { getArticleList } from '@/apis/modules/Information/index.js'
import { useRouter } from 'vue-router'
import { getHost } from '@/utils/domain.js'
export default {
  components: {
    titleColor,
  },
  data() {
    return {
      text: '优化供应链，只需要回答三个问题',
      backgroundImage: '@/assets/banner.png',
      articles: [],
      asd: '物流资讯',
      firstArticleTitle: '优化供应链，只需要回答三个问题', // 默认标题
      firstArticleImage: '@/assets/logisticsNews-img.png' // 默认图片
    }
  },
  computed: {
    // 计算第一篇文章的图片URL
    firstArticleImageUrl() {
      if (this.articles.length > 0 && this.articles[0].pics) {
        const pics = this.articles[0].pics
        if (typeof pics === 'string') {
          try {
            const parsed = JSON.parse(pics)
            if (Array.isArray(parsed)) {
              const firstPic = parsed[0]
              if (typeof firstPic === 'string') {
                try {
                  const innerParsed = JSON.parse(firstPic)
                  if (Array.isArray(innerParsed) && innerParsed.length > 0) {
                    return innerParsed[0] || this.firstArticleImage
                  }
                } catch (e) {
                  let fixedString = firstPic
                  if (!fixedString.endsWith(']')) {
                    fixedString += ']'
                  }
                  try {
                    const fixedParsed = JSON.parse(fixedString)
                    if (Array.isArray(fixedParsed) && fixedParsed.length > 0) {
                      return fixedParsed[0] || this.firstArticleImage
                    }
                  } catch (e2) {}
                }
              }
              if (Array.isArray(firstPic)) {
                return firstPic[0] || this.firstArticleImage
              }
              return firstPic || this.firstArticleImage
            }
            return pics
          } catch (e) {
            return pics
          }
        }
        return pics
      }
      return this.firstArticleImage
    },
    // 获取第一篇文章的ID
    firstArticleId() {
      return this.articles.length > 0 ? this.articles[0].id : null
    },
    otherArticles() {
      return this.articles.slice(1);
    }
  },
  name: 'LogisticsNews',
  async mounted() {
    await this.fetchArticles()
  },
  methods: {
    // 获取文章列表数据
    async fetchArticles() {
      try {
        const params = {
          pageNo: 1,
          pageSize: 5
        }
        const res = await getArticleList({ ...params, host: getHost() })
        if (res && res.statusCode === 20000 && res.data && Array.isArray(res.data.records)) {
          this.articles = res.data.records.map(item => ({
            id: item.id,
            title: item.title,
            pics: item.pics
          }))

          // 设置第一篇文章的标题
          if (this.articles.length > 0) {
            this.firstArticleTitle = this.articles[0].title
          }
        }
      } catch (error) {
        console.error('获取文章列表失败:', error)
      }
    },
    // 点击文章跳转到详情页
    openLogistics(id) {
      this.$router.push({
        name: 'LogisticsInformation-data',
        query: { id: id }
      })
    }
  }
};
</script>

<style scoped  lang="scss">
.logistics-news {
  width: 450px;
  height: 484px;
  background: #FFFFFF;
  box-shadow: 0px 8px 48px 0px rgba(0, 23, 77, 0.1);
  box-sizing: border-box;
  margin-left: 24px;
  padding: 30px 24px;
  .newsTop {
    height: 36px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .topright{
      font-size: 18px;
      display: flex;
      align-items: center;
      color: rgba(0, 27, 81, 0.4);
      text-decoration: none; /* 取消下划线 */
      img{
        width: 16px;
        height: 16px;
      }
    }
    .topright:hover{
      color: rgba(0, 27, 81, 1);
    }
  }
  .newsdetail{
    height: 190px;
    width: 100%;
    display: flex;
    background-size: cover; /* 背景图片覆盖整个容器 */
    background-position: center; /* 背景图片居中显示 */
    text-align: left;
    margin-bottom: 15px;
    /* text-overflow: ellipsis; */
  text{
    background: linear-gradient(90deg, rgba(0, 27, 81, 0.8) 0%, rgba(0, 27, 81, 0.63) 100%);
    color: white;
    overflow: hidden; /* 隐藏超出部分 */
    text-overflow: ellipsis; /* 显示省略号 */
    line-height: 42px;
    height: 42px;
    width: 100%;
    padding-left: 15px;
    position: relative;
    top: 148px;
    }
  }
  .newslist{
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 24px;
    view{
      height: 8px;
      width: 8px;
      background-color: #001B51;
      margin-right: 8px;
      flex-shrink: 0;
    }
    .news-title {
      max-width: 370px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
    }
  }
}

</style>
